import {
    CARVING_WRITING_VERTICAL,
    CARVING_WRITING_HORIZONTAL,
} from '@app/react/const/variables';

// eslint-disable-next-line no-control-regex
const getHalfChar = (str: string) => /[\x01-\x7E\uFF65-\uFF9F]/.exec(String(str));
// eslint-disable-next-line no-control-regex
const getWideChar = (str: string) => /[^\x01-\x7E]/.exec(String(str));

export const validateCarving = (
    txt: string,
    mode: number,
): [boolean, string | null] => {
    if (txt.length === 0) return [true, null];

    switch (mode) {
        case CARVING_WRITING_VERTICAL: {
            const halfChar = getHalfChar(txt);
            if ((halfChar?.length || 0) >= 1) return [false, '全角文字を入力してください'];
            return [true, null];
        }
        case CARVING_WRITING_HORIZONTAL: {
            const wideChar = getWideChar(txt);
            if ((wideChar?.length || 0) >= 1) return [false, '半角文字を入力してください'];
            return [true, null];
        }
        default:
            return [false, '書体を選択してください'];
    }
};
